import data from "@/licenses/third-party-licenses.json";

/**
 * One direct production dependency of the app, as written by
 * `scripts/generate-licenses.cjs` (monorepo root).
 */
export interface ThirdPartyPackage {
  name: string;
  version: string;
  /** SPDX identifier the package is used under. */
  license: string;
  /** Original SPDX expression when `license` was chosen from an "A OR B" choice. */
  licenseExpression: string | null;
  copyright: string | null;
  repository: string | null;
  /** "package" | "repository@<ref>" | "template" | null */
  licenseTextSource: string | null;
  /** Apache-2.0 §4(d) NOTICE file, redistributed verbatim. */
  noticeText: string | null;
  /** Index into `ThirdPartyNotice.licenseTexts`; null when no text could be found. */
  licenseTextIndex: number | null;
}

export interface ThirdPartyNotice {
  generatedAt: string;
  appName: string;
  appVersion: string;
  packages: ThirdPartyPackage[];
  /** Deduplicated full license texts. */
  licenseTexts: string[];
}

/**
 * THIRD PARTY NOTICE of the panel. The JSON is not committed – it is regenerated
 * on every `pnpm install` and every `pnpm build`, so it always matches the
 * dependencies that actually ship.
 */
export const thirdPartyNotice: ThirdPartyNotice = data;

export function licenseTextOf(pkg: ThirdPartyPackage): string | null {
  return pkg.licenseTextIndex === null
    ? null
    : (thirdPartyNotice.licenseTexts[pkg.licenseTextIndex] ?? null);
}
